import * as ids from '../layerIdStrings';

export const markerIconDefaultColor = {
	'search-result': '#00b3b3',
	'dialekt_record_place': '#57aa27',
	'dialekt_examples': '#EDE218',
	'dialekt_record_old': '#808080',
	'dialekt_record_new': '#EE82EE',
	'dialekt_record_cja': '#FFA500',
	'dialekt_record_place_all': '#3A6ED6',
	'dialekt_speaker_place_all': '#CE091C',
	//'cja_place': '#ff5e5e',
	'ortofon_examples': '#a83190', //'#b75594'
	'ucebne_pomocky_examples': '#92a2e8',
	'gemer_examples': '#63bd58',
};

const WEIGHT = 2;
const FILL_OPACITY = 0;
const dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);

export const overlayStyle = {
	'cz_hranice': (_) => {
		return {
			color: '#000',
			weight: WEIGHT,
			fillOpacity: FILL_OPACITY,
		};
	},
	'cz_kraje': (_) => {
		return {
			color: '#805500',
			weight: WEIGHT,
			fillOpacity: FILL_OPACITY,
		};
	},
	'cz_okresy': (_) => {
		return {
			color: '#e6b800',
			weight: WEIGHT,
			fillOpacity: FILL_OPACITY,
		};
	},
	[ids.DIALECTS_COARSE]: (feature) => {
		return {
			color: '#888888',
			fillColor: dialects[feature.properties['id']].color,
			//fillOpacity: 0.5,
			weight: WEIGHT,
		};
	},
	[ids.DIALECTS_FINE]: (feature) => {
		return {
			color: '#888888',
			fillColor: dialects[feature.properties['id']].color,
			//fillOpacity: 0.5,
			weight: WEIGHT,
		};
	},
	'cz_ceska-zemska-hranice': (_) => {
		return {
			color: '#550455',
			weight: 2.5,
		};
	},
	'cz_moravska-zemska-hranice': (_) => {
		return {
			color: '#550455',
			weight: 2.5,
		};
	},
	'cz_njo': (_) => {
		return {
			color: '#555',
			weight: WEIGHT,
		};
	},
	'obec': (_) => {
		return {
			color: '#222',
			fillOpacity: FILL_OPACITY,
			weight: 3,
			opacity: 0.5,
		};
	},
};

export const searchConfig = {
	language: 'sk', //'cs',
	placeholder: 'Obec, časť obce, číslo v ASJ',
};
